import script from "./followRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./followRecord.vue?vue&type=script&setup=true&lang=js"

import "./followRecord.vue?vue&type=style&index=0&id=f957f15e&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f957f15e"]])

export default __exports__